export default class ContractByIdModel {
    id_contrato: number | null;
    id_clube: string | null;
    tipo_contrato: number | null;
    id_status_contrato: number | null;
    tipo_contrato_pf: number | null;
    id_associado: string | null;
    nome_associado: string | null;

    constructor(
        id_contrato: number | null,
        id_clube: string | null,
        tipo_contrato: number | null,
        id_status_contrato: number | null,
        tipo_contrato_pf: number | null,
        id_associado: string | null,
        nome_associado: string | null
    ) {
        this.id_contrato = id_contrato;
        this.id_clube = id_clube;
        this.tipo_contrato = tipo_contrato;
        this.id_status_contrato = id_status_contrato;
        this.tipo_contrato_pf = tipo_contrato_pf;
        this.id_associado = id_associado;
        this.nome_associado = nome_associado;
    }

    static fromApiResponse(data: any): ContractByIdModel {
        return new ContractByIdModel(
            data.id_contrato || null,
            data.ID_CLUBE || null,
            data.tipo_contrato || null,
            data.ID_STATUS_CONTRATO || null,
            data.TIPO_CONTRATO_PF || null,
            data.ID_ASSOCIADO || null,
            data.associado?.nome || null
        );
    }

    static fromApiResponseArray(dataArray: any[]): ContractByIdModel[] {
        return dataArray.map(data => ContractByIdModel.fromApiResponse(data));
    }
}
